__webpack_require__.p = "/new-year-wishes/";